import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { LoginService } from '@ebw-monorepo/login';
import { PERMISSION_NAME, PermissionService, toSafeImageBlobUrl } from '@ebw-monorepo/utils';
import { map } from 'rxjs';
import { API_URLS, ApiUrlService } from '../../../../../../../utils/src/lib/services/api-url.service';
import { ShapeLayerStyleListModel } from '../../../../models/shape.model';
import { MapService } from '../../../../services/map.service';

@Component({
  selector: 'ebw-monorepo-show-layer-styles',
  templateUrl: './show-layer-styles.component.html',
  styleUrls: ['./show-layer-styles.component.scss']
})
export class ShowLayerStylesComponent implements OnInit {
  public layerStyleOptions: ShapeLayerStyleListModel[];

  public canAddStyle: boolean = false;
  public canUpdateStyle: boolean = false;
  public staticStylesList: string[] = [];

  public imageUrls = [];

  constructor(
    public dialogRef: MatDialogRef<ShowLayerStylesComponent>,
    private _mapService: MapService,
    private _httpClient: HttpClient,
    private _sanitizer: DomSanitizer,
    private _apiUrlService: ApiUrlService,
    @Inject(MAT_DIALOG_DATA) public data: { layerStylesOptions: ShapeLayerStyleListModel[] },
    private _permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.layerStyleOptions = this.data.layerStylesOptions;
    this.canAddStyle = this._permissionService.checkPermission(PERMISSION_NAME.MAP.SHAPE.ADD_LAYER_STYLE);
    this.canUpdateStyle = this._permissionService.checkPermission(PERMISSION_NAME.MAP.SHAPE.UPDATE_LAYER_STYLE);
    this.staticStylesList = this._mapService.mapConfigurationLoaded$.value.staticStyles;
    const opts = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + sessionStorage.getItem(LoginService.AUTH_TOKEN_KEY),
        user: sessionStorage.getItem(LoginService.USER_ID_KEY)
      })
    };
    this.imageUrls = this.layerStyleOptions.map((el) => {
      const imageUrl = this._apiUrlService.createUrl(API_URLS.MAP.LAYER.GET_LEGEND);
      return this._httpClient
        .get(`${imageUrl}?style=${el.image}`, { ...opts, responseType: 'blob' })
        .pipe(map((val) => toSafeImageBlobUrl(this._sanitizer, val)));
    });
  }

  public editStyle(name: string, style: any) {
    this.dialogRef.close(name);
  }

  public addNewLayerStyle() {
    this.dialogRef.close(-1);
  }

  public checkIfCanEdit(style: any) {
    let isStatic = Array.isArray(this.staticStylesList) ? this.staticStylesList.includes(style.name) : false;

    return this.canUpdateStyle && !isStatic;
  }
}
